import utils from 'utils'
class modalSynInvoicCtrl {
    constructor($scope, $timeout, $filter, $uibModalInstance, items1, logger, globalFn) {
        $scope.modaldata = {
            invoiceCode: '',
            invoiceNumber: '',
        }
        $scope = $.extend($scope, items1)
        // $scope.modaldata.invType = items1.invType || ''
        $scope.active = items1.active || 0
        const invoiceType = $scope.modaldata.invType
        $scope.ukeyList = JSON.parse(localStorage.user_info).sysUkeyList
        if(!$scope.ukeyList.length){
            logger.logError('未授权开盘点，不可以数据同步！')
            $scope.modaldata.ukeyId = ''
        } else{
            $scope.modaldata.ukeyId = $scope.ukeyList[0].ukeyId
        }
        $scope.modaldata.manageType = $scope.ukeyList[0].manageType
        $scope.ukeyChange = function () {
            const ukey = $scope.ukeyList.filter(i => {
                return i.ukeyId == $scope.modaldata.ukeyId
            })
            $scope.modaldata.manageType = ukey[0].manageType
            $scope.isWarn = false
            $scope.getInvTpye(1)
        }
        // 专票代码
        const invoiceCodeReg = /^[\d]{10}$|^[\d]{12}$/
        // 发票号码校验
        const invoiceNumReg = /^[\d]{8}$/
        // 日期设置
        $timeout(() => {
            const nowDate = new Date()
            const initStartDate = $filter('date')(nowDate, 'yyyy-MM-01')
            const initEndDate = $filter('date')(nowDate, 'yyyy-MM-dd')
            // var _initEndDate = globalFn.addDate(initStartDate,31);
            $('#datetimeStart1').val(initStartDate)
            $('#datetimeEnd1').val(initEndDate)
            $('#datetimeStart1').datetimepicker({
                autoclose: true,

                minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                language: 'zh-CN',
                format: 'yyyy-mm-dd',
                forceParse: 0,
                pickTime: false,
                pickerPosition: 'bottom-right',
                // startDate:"2017-01-01",
                // initialDate:now

            }).on('changeDate', (e) => {
                const dateText = e.date
                let endDate = globalFn.addDate(dateText, 365)
                endDate = globalFn.getTime2Time(initEndDate, endDate) >= 0 ? endDate : initEndDate
                $scope.modaldata.invoiceDateMin = e.target.value
                if (globalFn.getTime2Time($scope.modaldata.invoiceDateMax, $scope.modaldata.invoiceDateMin) > 365) {
                    // $('#datetimeEnd1').datetimepicker('setEndDate', endDate);
                    $scope.modaldata.invoiceDateMax = endDate
                    $('#datetimeEnd1').val(endDate)
                }
                // setStartDate setEndDate
                $('#datetimeEnd1').datetimepicker('setStartDate', dateText)
                $('#datetimeStart1').datetimepicker('setEndDate', $scope.modaldata.invoiceDateMax)
            })
            $('#datetimeEnd1').datetimepicker({
                autoclose: true,
                minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                language: 'zh-CN',
                format: 'yyyy-mm-dd',
                forceParse: 0,
                pickTime: false,
                pickerPosition: 'bottom-right',
                // startDate:"2017-01-01",
                // initialDate:now
            }).on('changeDate', (e) => {
                const dateText = e.date
                const startDate = globalFn.addDate(dateText, -365)
                $scope.modaldata.invoiceDateMax = e.target.value
                if (globalFn.getTime2Time($scope.modaldata.invoiceDateMax, $scope.modaldata.invoiceDateMin) > 365) {
                    $scope.modaldata.invoiceDateMin = startDate
                    $('#datetimeStart1').val(startDate)
                    // $('#datetimeStart1').datetimepicker('setStartDate', startDate);
                }
                $('#datetimeStart1').datetimepicker('setEndDate', dateText)
                $('#datetimeEnd1').datetimepicker('setStartDate', $scope.modaldata.invoiceDateMin)
            })
            $scope.modaldata.invoiceDateMin = initStartDate
            $scope.modaldata.invoiceDateMax = initEndDate
            $('#datetimeStart1').datetimepicker('setEndDate', initEndDate)
            $('#datetimeEnd1').datetimepicker('setStartDate', initStartDate)
            $('#datetimeEnd1').datetimepicker('setEndDate', initEndDate)
        }, 500)

        $scope.datetimeStartChange = function (e) {
            $scope.modaldata.invoiceDateMin = e.currentTarget.value
        }
        $scope.datetimeEndChange = function (e) {
            $scope.modaldata.invoiceDateMax = e.currentTarget.value
        }

        // 日期设置

        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function (v) {
            // 返回数据
            if ((($scope.modaldata.invoiceCode !== '' && !invoiceCodeReg.test($scope.modaldata.invoiceCode)) || ($scope.modaldata.invoiceNumber !== '' && !invoiceNumReg.test($scope.modaldata.invoiceNumber))) && $scope.modaldata.manageType != '2') {
                logger.logError('发票代码号码格式错误！')
                return
            }
            // if ($scope.modaldata.manageType == '2' && $scope.isWarn) return
            if ($scope.modaldata.manageType == '2' && !$scope.modaldata.invoiceCode) {
                $scope.isWarn = true
                $scope.tipMsg = `A9同步发票代码必填`
                return
            }
            $uibModalInstance.close($scope.modaldata)
        }
        // $scope.getInvTpye = function (v) {
        //     if (v && !$scope.modaldata.invoiceCode) return
        //     const invType = utils.getCodeToType($scope.modaldata.invoiceCode)
        //     if ($scope.modaldata.manageType == '2' && invType != invoiceType && !(invoiceType == '' && (invType == '0' || invType == '2'))) {
        //         $scope.isWarn = true
        //         let invTypeWord = ''
        //         switch (invoiceType) {
        //             case '':
        //                 invTypeWord = '专普票'
        //                 break;
        //             case 12:
        //                 invTypeWord = '机动车票'
        //                 break;
        //             case 51:
        //                 invTypeWord = '电子发票'
        //                 break;
        //             case 41:
        //                 invTypeWord = '卷式发票'
        //                 break;
        //             default:
        //                 break;
        //         }

        //         $scope.tipMsg = `输入的不是${invTypeWord}代码，请重新输入`
        //     }
        //     console.log(invType)
        // }
    }
}

modalSynInvoicCtrl.$inject = ['$scope', '$timeout', '$filter', '$uibModalInstance', 'items1', 'logger', 'globalFn']
export default modalSynInvoicCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/openedInvoice/modalSynInvoicCtrl.js